import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { Column, Padding } from '../..'
import { withSize } from '../../utils'

import Header from './Header'
import DeviceTypes from './DeviceTypes'
import OnlineDevices from './OnlineDevices'
import LatestNotes from './LatestNotes'
import LatestPlaylist from './LatestPlaylist'
import LatestMedia from './LatestMedia'
import NextScheduledPlaylist from './NextScheduledPlaylist'
import NextScheduledMedia from './NextScheduledMedia'
import { HeaderContainer, TopContainer, MiddleContainer } from './Dashboard.styles'

class Dashboard extends PureComponent {
    static propTypes = {
        data: PropTypes.shape({
            devices_offline: PropTypes.number,
            devices_online: PropTypes.number,
            last_updated_media: PropTypes.arrayOf(PropTypes.shape({})),
            last_updated_playlist: PropTypes.arrayOf(PropTypes.shape({})),
            latest_notes: PropTypes.arrayOf(PropTypes.shape({})),
            next_scheduled_media: PropTypes.arrayOf(PropTypes.shape({})),
            next_scheduled_playlist: PropTypes.arrayOf(PropTypes.shape({})),
            store_count: PropTypes.shape({
                total: PropTypes.number,
            }),
        }),
        loading: PropTypes.number,
        isMobile: PropTypes.bool,
    }

    static defaultProps = {
        data: {},
        loading: null,
        isMobile: false,
    }

    constructor(props) {
        super(props)

        this.state = {}
    }

    renderOnlineDevices = () => {
        const {
            data: { devices_offline: devicesOffline, devices_online: devicesOnline },
            loading,
        } = this.props

        return <OnlineDevices isEmpty={devicesOnline + devicesOffline === 0} loading={loading} online={devicesOnline} offline={devicesOffline} />
    }

    renderDeviceTypes = () => {
        const {
            data: { store_count: storeCount },
            loading,
        } = this.props
        const { total: totalDevices = 0, types: deviceTypes = {} } = storeCount || {}

        return <DeviceTypes isEmpty={!storeCount || !Object.keys(deviceTypes).length} loading={loading} total={totalDevices} types={deviceTypes} />
    }

    renderLatestNotes = () => {
        const {
            data: { latest_notes: latestNotes = [] },
            loading,
        } = this.props

        return <LatestNotes isEmpty={!latestNotes || !latestNotes.length} loading={loading} notes={latestNotes} />
    }

    renderLatestPlaylist = () => {
        const {
            data: { last_updated_playlist: latestPlaylist = [] },
            loading,
        } = this.props

        return <LatestPlaylist isEmpty={!latestPlaylist || !latestPlaylist.length} loading={loading} name={(latestPlaylist[0] || {}).name} />
    }

    renderLatestMedia = () => {
        const {
            data: { last_updated_media: latestMedia = [] },
            loading,
        } = this.props
        const media = latestMedia[0] || {}
        const { id, name } = media

        return <LatestMedia isEmpty={!latestMedia || !latestMedia.length} loading={loading} id={id} name={name} />
    }

    renderNextScheduledPlaylist = () => {
        const {
            data: { next_scheduled_playlist: nextPlaylist = [] },
            loading,
        } = this.props
        const media = nextPlaylist[0] || {}
        const { id, name } = media

        return <NextScheduledPlaylist isEmpty={!nextPlaylist || !nextPlaylist.length} loading={loading} id={id} name={name} />
    }

    renderNextScheduledMedia = () => {
        const {
            data: { next_scheduled_media: nextMedia = [] },
            loading,
        } = this.props
        const media = nextMedia[0] || {}
        const { id, name } = media

        return <NextScheduledMedia isEmpty={!nextMedia.length} loading={loading} id={id} name={name} />
    }

    renderAsPC = () => (
        <Padding size="md" fullHeight>
            <HeaderContainer bottom size="md">
                <Header />
            </HeaderContainer>
            {/* Top Containers */}
            <TopContainer bottom size="md">
                <Column width="50%">
                    <Padding right size="sm" fullHeight hideOverflow>
                        {this.renderOnlineDevices()}
                    </Padding>
                </Column>
                <Column width="50%">{this.renderDeviceTypes()}</Column>
            </TopContainer>
            <MiddleContainer bottom size="md">
                <Column width="20%">
                    <Padding right size="sm" fullHeight hideOverflow>
                        {this.renderLatestNotes()}
                    </Padding>
                </Column>
                <Column width="20%">
                    <Padding right size="sm" fullHeight hideOverflow>
                        {this.renderLatestPlaylist()}
                    </Padding>
                </Column>
                <Column width="20%">
                    <Padding right size="sm" fullHeight hideOverflow>
                        {this.renderLatestMedia()}
                    </Padding>
                </Column>
                <Column width="20%">
                    <Padding right size="sm" fullHeight hideOverflow>
                        {this.renderNextScheduledPlaylist()}
                    </Padding>
                </Column>
                <Column width="20%">{this.renderNextScheduledMedia()}</Column>
            </MiddleContainer>
        </Padding>
    )

    renderAsMobile = () => (
        <Padding size="md" fullHeight>
            <HeaderContainer bottom size="md">
                <Header />
            </HeaderContainer>
            <Column width="100%">
                <Padding noPadding size="sm" hideOverflow>
                    {this.renderOnlineDevices()}
                </Padding>
                <Padding noPadding size="sm" hideOverflow>
                    {this.renderDeviceTypes()}
                </Padding>
                <Padding noPadding size="sm" hideOverflow>
                    {this.renderLatestNotes()}
                </Padding>
                <Padding noPadding size="sm" hideOverflow>
                    {this.renderLatestPlaylist()}
                </Padding>
                <Padding noPadding size="sm" hideOverflow>
                    {this.renderLatestMedia()}
                </Padding>
                <Padding noPadding size="sm" hideOverflow>
                    {this.renderNextScheduledPlaylist()}
                </Padding>
                <Padding noPadding size="sm" hideOverflow>
                    {this.renderNextScheduledMedia()}
                </Padding>
            </Column>
        </Padding>
    )

    render() {
        const { isMobile } = this.props

        return isMobile ? this.renderAsMobile() : this.renderAsPC()
    }
}

export default withSize(Dashboard)
